import { OSUpdateStatus } from '@rocksoft/mdm-sdk-v2';

import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export interface OsUpdateStatus extends OSUpdateStatus {
  udid: string;
}

export type OsUpdateStatusState = EntityState<OsUpdateStatus>;

export function selectId(status: OsUpdateStatus) {
  return `${status.udid}-${status.productKey}`;
}

export const adapter: EntityAdapter<OsUpdateStatus> = createEntityAdapter<OsUpdateStatus>({
  selectId,
});

export const initialState: OsUpdateStatusState = adapter.getInitialState();
